import script from "./SimulationHistoryPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SimulationHistoryPage.vue?vue&type=script&setup=true&lang=js"

import "./SimulationHistoryPage.vue?vue&type=style&index=0&id=75d6f53a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75d6f53a"]])

export default __exports__